import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AppUpdateFailedDialogData {
  serverVersion: string;
  clientVersion: string;
}

@Component({
  selector: 'app-update-failed-dialog',
  templateUrl: './app-update-failed-dialog.component.html',
  styleUrls: ['./app-update-failed-dialog.component.css'],
  standalone: false,
})
export class AppUpdateFailedDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppUpdateFailedDialogData,
    private dialogRef: MatDialogRef<AppUpdateFailedDialogComponent>,
  ) {}

  goToHelp(): void {
    this.dialogRef.close({ action: 'help' });
  }

  close(): void {
    this.dialogRef.close({ action: 'close' });
  }

  forceUpdate(): void {
    this.dialogRef.close({ action: 'force' });
  }

}
